const EVENTS = {
  CLICK: 'click',
  HOVER: 'hover',
  SCROLL: 'scroll',
};

const ACTION_ON = {
  APPLICANT_GET_STARTED: 'Applicant_Get_Started_Button',
  APPLICANT_CHECK_ELIGIBILITY: 'Applicant_Check_Eligibility_Button',
  APPLICANT_RETAKE_ELIGIBILITY_QUIZ: 'Applicant_Retake_Eligibility_Quiz_Button',
  APPLICANT_START_APPLICATION: 'Applicant_Start_Application_Button',
  APPLICANT_GENERATE_EMAIL_VALIDATION_CODE: 'Applicant_Generate_Email_Validation_Code_Button',
  APPLICANT_RESEND_EMAIL_VALIDATION_CODE: 'Applicant_Resend_Email_Validation_Code_Button',
  APPLICANT_VALIDATE_EMAIL_VALIDATION_CODE: 'Applicant_Validate_Email_Validation_Code_Button',
  APPLICANT_SUBMIT_COMMUNICATION_PREFERENCES: 'Applicant_Submit_Communication_Preferences_Button',
  APPLICANT_SAVINGS_INCOME_CONTINUE: 'Applicant_Savings_Income_Continue_Button',
  APPLICANT_SAVINGS_INCOME_SAVE_EXIT: 'Applicant_Savings_Income_Save_Exit_Button',
  APPLICANT_EXPENSES_CONTINUE: 'Applicant_Expenses_Continue_Button',
  APPLICANT_EXPENSES_SAVE_EXIT: 'Applicant_Expenses_Save_Exit_Button',
  APPLICANT_HARDSHIP_CONTINUE: 'Applicant_Hardship_Continue_Button',
  APPLICANT_HARDSHIP_SAVE_EXIT: 'Applicant_Hardship_Save_Exit_Button',
  APPLICANT_GRANT_CONTINUE: 'Applicant_Grant_Continue_Button',
  APPLICANT_GRANT_SAVE_EXIT: 'Applicant_Grant_Save_Exit_Button',
  APPLICANT_REVIEW_APPLICATION_BUTTON: 'Applicant_Review_Application_Button',
  APPLICANT_REVIEW_AND_SUBMIT_BACK_BUTTON: 'Applicant_Review_And_Submit_Back_Button',
  APPLICANT_REVIEW_AND_SUBMIT_BUTTON: 'Applicant_Review_And_Submit_Button',
  APPLICANT_BACK_TO_ACNT_HOMEPAGE_BUTTON: 'Applicant_Back_To_Acnt_Homepage_Button',
  APPLICANT_HELPFUL_RESOURCES_LEARN_MORE: 'Applicant_Helpful_Resources_Learn_More_Button',
  ACNT_APPLICATION_LOGOUT: 'Acnt_Application_Logout_Button',
  APPLICANT_GRANT_VIEW_APPLICATION: 'Applicant_Grant_View_Application_Button',
  APPLICANT_GRANT_DETAILS_BACK_TO_DASHBOARD: 'Applicant_Grant_Details_Back_To_Dashboard_Button',
  APPLICANT_VIEW_APPLICATION: 'Applicant_View_Application_Button',
  APPLICANT_CANCEL_APPLICATION: 'Applicant_Cancel_Application_Button',
  APPLICANT_UPDATE_APPLICATION: 'Applicant_Update_Application_Button',
  APPLICANT_ADD_EMAIL: 'Applicant_Add_Email_Button',
  APPLICANT_EDIT_EMAIL: 'Applicant_Edit_Email_Button',
  APPLICANT_ADD_PHONE_NUMBER: 'Applicant_Add_Phone_Number_Button',
  APPLICANT_EDIT_PHONE_NUMBER: 'Applicant_Edit_Phone_Number_Button',
  APPLICANT_BACK_TO_NEW_GRANT_APPLICATION_BUTTON: 'Applicant_Back_To_New_Grant_Application_Button',
  APPLICANT_UPDATE_COMMUNICATION_PREFERENCES: 'Applicant_Update_Communication_Preferences_Button',
  APPLICANT_CONTINUE_COMMUNICATION_PREFERENCES: 'Applicant_Continue_Communication_Preferences_Button',
  APPLICANT_APPLICATION_ASSOCIATE_TYPE: 'Applicant_Application_Associate_Type_Button',
  APPLICANT_APPLICATION_DISASTER_TYPE: 'Applicant_Application_Disaster_Type_Button',
  APPLICANT_PAST_REQUESTS_DELETE: 'Applicant_Past_Requests_Delete_Button',
  APPLICANT_ELIGIBILITY_QUIZ_INFO_MODAL: 'Applicant_Eligibility_Quiz_Info_Modal_Button',
  APPLICANT_ELIGIBILITY_QUIZ_INFO_MODAL_CLOSE: 'Applicant_Eligibility_Quiz_Info_Modal_Close_Button',
  APPLICANT_VIEW_RECENT_APPLICATION: 'Applicant_View_Recent_Application_Button',
  APPLICANT_PAYMENT_SAVE_EXIT: 'Applicant_Payment_Save_Exit_Button',
  APPLICANT_PAYMENT_CONTINUE: 'Applicant_Payment_Continue_Button',
  APPLICANT_SMS_NOTIFICATIONS: 'Applicant_SMS_Notifications_Button',
  APPLICANT_VALIDATE_EMAIL: 'Applicant_Validate_Email_Button',
  APPLICANT_VALIDATE_EMAIL_AND_PHONE: 'Applicant_Validate_Email_And_Phone_Button',
  REVIEWER_EXCEL_EXPORT_BUTTON: 'Reviewer_Excel_Export_Button',
  REVIEWER_DASHBOARD_FILTERS_BUTTON: 'Reviewer_Dashboard_Filters_Button',
  REVIEWER_SAVE_DASHBOARD_FILTERS_BUTTON: 'Reviewer_Save_Dashboard_Filters_Button',
  REVIEWER_APPLY_DASHBOARD_FILTERS_BUTTON: 'Reviewer_Apply_Dashboard_Filters_Button',
  REVIEWER_RESET_DASHBOARD_FILTERS_BUTTON: 'Reviewer_Reset_Dashboard_Filters_Button',
  REVIEWER_DASHBOARD_SEARCH_BUTTON: 'Reviewer_Dashboard_Search_Button',
  REVIEWER_DASHBOARD_RESET_SEARCH_BUTTON: 'Reviewer_Dashboard_Reset_Search_Button',
  REVIEWER_DASHBOARD_SHARE_APPLICATION_BUTTON: 'Reviewer_Dashboard_Share_Application_Button',
  REVIEWER_DASHBOARD_OPEN_APPLICATION_BUTTON: 'Reviewer_Dashboard_Open_Application_Button',
  REVIEWER_ASSIGN_APPLICATION_BUTTON: 'Reviewer_Assign_Application_Button',
  REVIEWER_UNASSIGN_APPLICATION_BUTTON: 'Reviewer_UnAssign_Application_Button',
  REVIEWER_SHARE_APPLICATION_BUTTON: 'Reviewer_Share_Application_Button',
  REVIEWER_VIEW_LOGS_BUTTON: 'Reviewer_View_Logs_Button',
  REVIEWER_CLOSE_VIEW_LOGS_BUTTON: 'Reviewer_Close_View_Logs_Button',
  REVIEWER_PREVIEW_FILE_BUTTON: 'Reviewer_Preview_File_Button',
  REVIEWER_DOWNLOAD_FILE_BUTTON: 'Reviewer_Download_File_Button',
  REVIEWER_VIEW_ALL_PAST_APPLICATIONS_BUTTON: 'Reviewer_View_All_Past_Applications_Button',
  REVIEWER_CLOSE_VIEW_ALL_PAST_APPLICATIONS_BUTTON: 'Reviewer_Close_View_All_Past_Applications_Button',
  REVIEWER_RETURN_BACK_TO_DASHBOARD_BUTTON: 'Reviewer_Return_Back_To_Dashboard_Button',
  REVIEWER_HARDSHIP_SAVE_AND_CONTINUE_BUTTON: 'Reviewer_Hardship_Save_&_Continue_Button',
  REVIEWER_GRANT_SAVE_AND_CONTINUE_BUTTON: 'Reviewer_Grant_Save_&_Continue_Button',
  REVIEWER_APPROVE_GRANT_BUTTON: 'Reviewer_Approve_Grant_Button',
  REVIEWER_REJECT_GRANT_BUTTON: 'Reviewer_Reject_Grant_Button',
  REVIEWER_REJECT_GRANT_CONFIRMATION_MODAL_BUTTON: 'Reviewer_Reject_Grant_Confirmation_Modal_Button',
  REVIEWER_REJECT_CONFIRMATION_MODAL_CLOSE_BUTTON: 'Reviewer_Reject_Confirmation_Modal_Close_Button',
  REVIEWER_RETURNS_TO_APPLICANT_BUTTON: 'Reviewer_Returns_To_Applicant_Button',
  REVIEWER_DASHBOARD_MY_APPLICATIONS: 'Reviewer_Dashboard_My_Applications_Button',
  REVIEWER_DASHBOARD_NAVIGATE_APPLICATION: 'Reviewer_Dashboard_Navigate_Application_Button',
  REVIEWER_REJECT_CONFIRMATION_MODAL_CANCEL: 'Reviewer_Reject_Confirmation_Modal_Cancel_Button',
  REVIEWER_APPROVE_MODAL_CLOSE: 'Reviewer_Approve_Modal_Close_Button',
  REVIEWER_APPROVE_MODAL_CANCEL: 'Reviewer_Approve_Modal_Cancel_Button',
  REVIEWER_APPROVE_MODAL_APPROVE: 'Reviewer_Approve_Modal_Approve_Button',

  ADMIN_FINANCE_DETAILED_REPORT: 'Admin_Finance_Detailed_Report_Button',
  ADMIN_FINANCE_D2C_REPORT: 'Admin_Finance_D2C_Report_Button',
  ADMIN_FINANCE_RECON_REPORT: 'Admin_Finance_Recon_Report_Button',
  ADMIN_OUTSTANDING_REPORT: 'Admin_Outstanding_Report_Button',
};

export default {
  ACTION_ON,
  EVENTS,
};
